class FetchApiWrapperService {
  constructor() {}

  public async get<T>(endpoint: string, bearer?: string): Promise<T> {
    try {
      const headers: Record<string, string> = {
        'Content-Type': 'application/json'
      }

      if (bearer) {
        headers.Authorization = `Bearer ${bearer}`
      }

      const response = await fetch(endpoint, {
        method: 'GET',
        headers
      })

      return this.handleResponse<T>(response)
    } catch (error: any) {
      throw new Error(`Error sending GET request: ${error.message}`)
    }
  }

  public async put<T, X>(endpoint: string, request: X, bearer: string): Promise<T> {
    try {
      const response = await fetch(endpoint, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${bearer}`
        },
        body: JSON.stringify(request)
      })

      return this.handleResponse<T>(response)
    } catch (error: any) {
      throw new Error(`Error sending POST request: ${error.message}`)
    }
  }

  public async post<T, X>(endpoint: string, request: X): Promise<T> {
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(request)
      })

      return this.handleResponse<T>(response)
    } catch (error: any) {
      throw new Error(`Error sending POST request: ${error.message}`)
    }
  }

  private async handleResponse<T>(response: Response): Promise<T> {
    if (!response.ok) {
      throw new Error(`Request failed with status: ${response.status}`)
    }

    if (response.status === 200 || response.status === 201) {
      return response.json() as Promise<T>
    }

    return Promise.resolve(undefined as T)
  }
}
export default new FetchApiWrapperService()
